import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Session, SessionService, GraphQlService } from '../../../_services';
import { Transition } from '@uirouter/angular';
import { Principal } from '../../../shared/auth/principal.service';

@Component({
    selector: 'session-update',
    templateUrl: './update.component.html',
    styleUrls: ['./update.style.scss'],
    providers: [TranslatePipe],
})
export class SessionUpdateComponent implements OnInit {
    currentSession: Session;
    sessionId: number;

    constructor(
        private sessionService: SessionService,
        private trans: Transition,
        private graphQlService: GraphQlService,
        private principal: Principal
    ) {}

    ngOnInit(): void {
        this.sessionId = this.trans.params()['id'];
        this.sessionService.findOne(this.sessionId).subscribe((session) => {
            this.currentSession = session;
            if (this.currentSession.training) {
                this.fetchMaterialReadyValue(this.currentSession.training.id);
            }
        });
    }

    fetchMaterialReadyValue(trainingId: number, language = 'fr') {
        if (!trainingId) {
            return null;
        }
        return this.graphQlService
            .post({
                query: `
                    query($trainingId: bigint!, $language: String!) {
                      trainingMetadata: plt_training_metadata(
                        limit: 1,
                        where: { training_id: { _eq: $trainingId }, language: { _eq: $language } }
                      ) {
                        materialReady: material_ready
                      }
                    }
                `,
                variables: {
                    trainingId,
                    language,
                },
            })
            .subscribe((materialReadyValues) => {
                if (materialReadyValues.length === 0) {
                    this.currentSession.training.materialReady = null;
                } else {
                    this.currentSession.training.materialReady =
                        materialReadyValues.trainingMetadata[0].materialReady;
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/update/update.component.ts